module.exports = __webpack_public_path__ + "img/try-it-now.9fd42463.svg";